export const CollaboratorData = {
    id: "123456789",
    nom: "Doe",
    prenom: "John",
    email: "John@Doe.com",
    categorie: "Executive",
    denomination: "Avantage",
    montant: "100",
    freq: "mensuel",
}

export const SinistreData = [
    {Date: "01/01/2021", Nom: "Doe", Statut: "En cours"},
    {Date: "01/01/2021", Nom: "Doe", Statut: "En cours"},
]

export const VehiculeData = {
    number: "XX-XXX-XX",
    Duree: "12 mois",
    DateAffection: "01/01/2021",
    DateFin: "01/01/2022",
}

export const HistoryData = [
    {date: "01/01/2021", number: "XX-XXX-XX", type: "Affectation", nom: "Doe"},
    {date: "01/01/2021", number: "XX-XXX-XX", type: "Affectation", nom: "Doe"},
    {date: "01/01/2021", number: "XX-XXX-XX", type: "Affectation", nom: "Doe"},
]

export const PhotosData = [
    { id: "1", name: "Photo 1", },
    { id: "2", name: "Photo 2", },
]

export const InformationData = {
    dateIntervention: "01/01/2021",
    dateSinistre: "01/01/2021",
    intervantion: "Lorem ipsum dolor sit amet",
}
